<script setup>

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
    name: {
        type: String,
        required: true
    },
    limit: {
        type: Number,
        required: true,
    },
    value: {
        type: Number,
        required: true,
    },
    before_value: {
        type: Number,
        required: false,
    },
    due_date: {
        type: String,
        default: "",
    },
    status: {
        type: String,
        default: "text-success"
    },
    id: {
        type: String,
        default: "",
    },
    icon: {
        type: String,
        default: "",
    },
    sum: {
        type: Number,
        required: false
    },
    fixes: {
        type: Number,
        required: false
    },
    installments: {
        type: Number,
        required: false
    },
    darkmode: {
        type: Boolean,
        default: false
    }
    
});

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

function formatDate(d){
    
    let date = new Date(d);

    let options = {
                    month: 'numeric',
                    day: 'numeric',
                    timeZone: 'UTC'
                };
    
    return date.toLocaleDateString(t('message.global.date_language'), options);

}

function calcPercent(limit, limit_used){

    let percent = (parseFloat(limit_used) / parseFloat(limit)) * 100;

    return percent

}

function invoiceStatus(status, type){

    if(status == 'Open' || status == 'Current'){

        if(type == 'class'){
            return 'secondary';
        }
        else if(type == 'title'){
            return t('message.global.open');
        }

    }
    else if(status == 'Closed'){

        if(type == 'class'){
            return 'warning';
        }
        else if(type == 'title'){
            return t('message.global.closed');
        }

    }
    else if(status == 'Paid'){

        if(type == 'class'){
            return 'success';
        }
        else if(type == 'title'){
            return t('message.global.payed');
        }
        
    }


}
</script>

<template>
    <div class="row align-items-center row-cards">

        <div class="col-10 align-content-between d-flex align-items-center">
            <img :src="icon" alt="Banco Logo" width="48" class="rounded-5 ms-2 me-3">
            <div>
                <p class="mt-n1 mb-n1 font-weight-bold text-dark">{{ name }} <span class="badge badge-sm ms-1" :class="'bg-' + invoiceStatus(status, 'class')">{{ invoiceStatus(status, 'title') }}</span></p>
                
                <span class="text-sm">{{ formatDate(due_date) }}</span>
            </div>
        </div>

        <div class="col-2 text-end">

            <router-link :to="'/fatura/'+id" class="me-3">
                <i class="fal fa-file-invoice row-accounts-list-icons-actions" :class="darkmode ? 'text-white-50' : 'text-black-50'" v-tooltip="{
                                    content:'Ver fatura',
                                    distance: 15
                                }"></i>
            </router-link>

        </div>

        <div class="col-11 mx-auto mt-2 mb-1">
            <div class="row">
                <div class="col text-xs">
                    {{t('message.global.limit')}}
                    <br>
                    <span class="font-weight-bold" :class="darkmode ? 'text-white' : 'text-dark '">{{ formatMoney((parseFloat(limit))) }}</span>
                </div>
                <div class="col text-xs text-center">
                    {{t('message.global.invoice_value')}}
                    <br>
                    <span class="font-weight-bold" :class="darkmode ? 'text-white' : 'text-dark '">{{ formatMoney((parseFloat(value) + parseFloat(before_value))) }}</span>
                </div>
                <div class="col text-xs text-end">
                    {{t('message.global.available_limit')}}
                    <br>
                    <span class="font-weight-bold" :class="darkmode ? 'text-white' : 'text-dark '">
                        {{ formatMoney(parseFloat(limit) - (parseFloat(value) + parseFloat(installments ? installments : 0) + parseFloat(before_value))) }}
                    </span>
                </div>
            </div>
        </div>

        <div class="col-11 mx-auto mb-4">
            <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                <div class="progress-bar" :style="'width: '+calcPercent(limit, (parseFloat(value) + parseFloat(installments ? installments : 0) + parseFloat(before_value)))+'%'" :class="calcPercent(limit, (parseFloat(value) + parseFloat(installments ? installments : 0) + parseFloat(before_value))) >= 90 ? 'bg-danger' : calcPercent(limit, (parseFloat(value) + parseFloat(installments ? installments : 0) + parseFloat(before_value))) >= 30 ? 'bg-warning' : calcPercent(limit, (parseFloat(value) + parseFloat(installments ? installments : 0) + parseFloat(before_value))) >= 0 ? 'bg-success' : ''"></div>
            </div>
        </div>

    </div>
</template>

<style>
    .row-cards{
        min-height: 70px;
    }

    .card-title{
            font-size: 14px;
        }

    @media (max-width: 575.98px) {
        .card-title{
            font-size: 13px;
        }
    }
</style>